import React from 'react'
import { withRouter } from "react-router-dom";
import { TableOp } from '../../components/table/TableOps.tsx';
import TableComponent from '../../components/table/TableOps';
import ListaPrecios from './ListaPrecios';
import ACCESS from '../../ACCESS.js';
import { AuthContext } from '../../context/authContext.js';

class ListaPreciosIndex extends TableComponent {

  componentDidMount() {
    this.tableConfig(
      { dataUrl: 'lista-precio/filter', deleteUrl: 'cargo-credito/delete', deleteField: 'lp_nobre', modUrl: '/ListaPreciosEdit' },
      TableOp.Table('Listas de Precios', [
        { label: 'Nombre de la lista de precios', id: 'lp_nombre' },
      ], [
        { id: 'edit', icon: 'edit', hasAccess: [ACCESS.LISTA_PRECIOS.EDITAR_LISTA_PRECIO] },
        /*         { id: 'delete', icon: 'delete' }, */
      ]))
    this.table();
  }

  render() {
    const { hasAccess } = this.context
    return (
      <div>
        <div>
          {
            hasAccess([ACCESS.LISTA_PRECIOS.CREAR_LISTA_PRECIO]) &&
            <ListaPrecios onSave={() => { this.table() }}></ListaPrecios>
          }
          {
            hasAccess([ACCESS.LISTA_PRECIOS.VER_LISTA_PRECIOS]) &&
            <this.TableRender  />
          }
        </div>
      </div>
    )
  }
}

ListaPreciosIndex.contextType = AuthContext;
export default withRouter(ListaPreciosIndex)